import { Caption } from '@cian/ui-kit';
import * as React from 'react';

import { getIsUserIdentifiedByDocuments } from './utils';
import { AgentWorkHonestlyProofs } from '../../../../components/AgentWorkHonestlyProofs';
import { useOfferContext } from '../../../../context';

export const AgentWorkHonestlyProofsContainer = () => {
  const offerData = useOfferContext();
  const isUserIdentifiedByDocuments = getIsUserIdentifiedByDocuments(offerData);
  const { agentInfo } = offerData;

  if (!isUserIdentifiedByDocuments) {
    return null;
  }

  return (
    <>
      {isUserIdentifiedByDocuments && <AgentWorkHonestlyProofs message="Документы проверены" />}
      {agentInfo && <Caption color="text-secondary-default">{agentInfo}</Caption>}
    </>
  );
};
